import React from "react";
import { Flex, Text } from "@chakra-ui/react";

export default function InputWrapper({ label, children }) {
	return (
		<Flex
			flexDir={"column"}
			gap={1}
			alignItems={"flex-start"}
			w={["100%", "400px"]}
			position={"relative"}
			pt={5}
		>
			<Text
				fontWeight={600}
				fontSize={14}
				position={"absolute"}
				top={0}
				left={0}
			>
				{label}
			</Text>
			{children}
		</Flex>
	);
}
